import { render, staticRenderFns } from "./EmployeeManage.vue?vue&type=template&id=6010e4ae&scoped=true"
import script from "./EmployeeManage.vue?vue&type=script&lang=js"
export * from "./EmployeeManage.vue?vue&type=script&lang=js"
import style0 from "./EmployeeManage.vue?vue&type=style&index=0&id=6010e4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6010e4ae",
  null
  
)

export default component.exports